import React from 'react';
import { getProviderImageUrl } from "../utils/providers";
import bn from "../utils/bemnames";
import { formatOdds, getOutLink } from "../utils/odds";
import {IProvider, oddsFormats} from '../utils/types';
import OddsTrackingLink from './OddsTrackingLink';
import {useGlobalState} from '../contexts/GlobalState';

const bem = bn.create('odds-button');

interface IProps {
  width: number;
  odds: number;
  oddsFormat?: oddsFormats;
  provider: IProvider;
  providerSlug: string;
  outLinkFolder: string|null|undefined;
  oddsChangeStatus?: string;
  widgetId?: number,
  logoType: string
}

const OddsButtonWithProviderLogo: React.FC<IProps> = (props) => {
  const { width, odds, oddsFormat, provider, providerSlug, outLinkFolder, widgetId = undefined, oddsChangeStatus = '', logoType } = props;
  const {globalState} = useGlobalState();

  return (
    <>
      {provider && <OddsTrackingLink
        className={bem.e('odds-box-link')}
        outLink={getOutLink(outLinkFolder, providerSlug, widgetId)}
        target={'_blank'}
        rel={'noreferrer'}
        providerId={provider.id}
        widgetId={widgetId ?? globalState.widget?.id}
      >
        <span className={bem.e('odds-value')}>
          <div>
            {formatOdds(odds, oddsFormat)}
          </div>
          <div className={bem.e(oddsChangeStatus)} />
        </span>
        <span style={{width: width}} className={bem.e('odds-logo')}>
          <img src={getProviderImageUrl(provider, logoType)} alt={provider.name}/>
        </span>
      </OddsTrackingLink>}
    </>
  )
}

export default OddsButtonWithProviderLogo;
